<template>
  <div class="overflow-auto overflow-x-hidden pr-1">
    <div class="row">
      <div class="col-12 col-xl-6 mb-6">
        <div>
          <BaseTable :items="dashboard.newCases" header="New cases" :row-click="openCase" />
        </div>
      </div>
      <div class="col-12 col-xl-6 mb-6">
        <div>
          <BaseTable :items="dashboard.closedCases" header="Recently closed cases" :row-click="openCase" />
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12 col-xl-6 mb-6">
        <div>
          <ReportTable :items="dashboard.newReports" header="New reports" :row-click="openReports" />
        </div>
      </div>
      <div class="col-12 col-xl-6 mb-6">
        <div>
          <LoginTable v-if="dashboard.lastUsersLogin" :items="dashboard.lastUsersLogin" header="Latest App Login" />
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12 col-xl-6 mb-6">
        <div v-if="isLoaded" class="d-flex justify-content-center">
          <div style="height: 500px; width: 500px; overflow: hidden">
            <PieChart :data="chartData" :options="chartOptions" :height="500" :width="500" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import axios from 'axios';
import { DashboardMixin, NotificationMixin, ApiMixin } from '../../../../mixins';
import PieChart from '../Charts/pie-chart.vue';
import BaseTable from './base-table';
import ReportTable from './report-table';
import LoginTable from './login-table';
import { CASE_STATUSES } from '../../../../../../../constants';

export default {
  name: 'Dashboard',
  components: { BaseTable, LoginTable, PieChart, ReportTable },
  mixins: [DashboardMixin, NotificationMixin, ApiMixin],
  data: function () {
    return {
      baseURL: axios.defaults.baseURL,
      statuses: CASE_STATUSES,
      dashboard: {
        closedCases: [],
        lastUsersLogin: null,
        newCases: [],
        newReports: [],
      },
      isLoaded: false,
      chartOptions: {
        hoverBorderWidth: 5,
      },
      chartData: {
        hoverBorderWidth: 10,
        labels: [this.$translate('Active Cases'), this.$translate('In progress Cases'), this.$translate('Closed Cases')],
        datasets: [
          {
            label: 'Cases',
            backgroundColor: ['#28a745', '#ffc107', '#007bff'],
            data: [0, 0, 0],
          },
        ],
      },
    };
  },
  created() {
    this.loadDashboard();
  },
  methods: {
    openReports(c) {
      this.$router.push({ name: 'report-details', params: { id: c.id } });
    },
    openCase(c) {
      this.$router.push({ name: 'case-details', params: { id: c.id } });
    },
    async loadDashboard() {
      try {
        this.isLoaded = false;
        const formateData = ({ data }) => {
          return data.map((item) => {
            item.teamName = item.team ? item.team.name : '';
            item.userName = item.user ? item.user.name : '';
            item.updatedAt = moment(item.updatedAt).format('DD.MM.YY HH:mm');
            item.lastLoggedInAt = item.lastLoggedInAt ? moment(item.lastLoggedInAt).format('DD.MM.YY HH:mm') : '';
            const color = (() => {
              switch (item.status) {
                case this.statuses.ACTIVE:
                  return 'success';
                case this.statuses.IN_PROGRESS:
                  return 'info';
                case this.statuses.FINISHED:
                  return 'secondary';
                default:
                  return 'secondary';
              }
            })();
            item.statusColor = color;
            item.status = this.$translate(item.status);
            return item;
          });
        };
        const response = await this.dashboardService.getReportsDashboard();
        const {
          data: { closedCases, lastUsersLogin, newCases, newReports, finishedCases, activeCases, inprogressCases },
        } = response;
        this.dashboard = {
          closedCases: formateData(closedCases),
          lastUsersLogin: lastUsersLogin ? formateData(lastUsersLogin) : null,
          newCases: formateData(newCases),
          newReports: formateData(newReports),
        };
        this.chartData.datasets[0].data = [activeCases, inprogressCases, finishedCases];
        this.isLoaded = true;
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.label,
.description {
  color: #7586a5;
}

.error {
  color: red;
}

.section-header {
  margin: 0;
}

h5 {
  margin-bottom: 20px;
}

button {
  width: 170px;
}

@media (max-width: 768px) {
  button {
    margin-top: 20px;
  }
}

@media (min-width: 768px) {
  button {
    float: right;
  }
}

.main-content {
  height: 100%;
  max-height: 100%;
  min-height: fit-content;
}

.today-container {
  border-bottom: 1px solid lightgrey;
  padding-bottom: 5px;
}

.yesterday-container {
  border-right: 1px solid lightgrey;
}

p {
  margin-bottom: 0.5rem;
}

.grey-text {
  color: #7586a5;
}

.card-bottom {
  position: absolute;
  bottom: 20px;
  right: 30px;
}

.card-container {
  background: #ffffff;
  padding: 15px;
  height: 100%;
  min-height: 130px;
  font-size: 0.9rem;
}

.img-preview {
  height: 58px;
}

.img-box {
  display: flex;
  justify-content: center;
  width: 100%;
  top: 11px;
  left: 0;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}
</style>
